import { render, staticRenderFns } from "./equipment4.vue?vue&type=template&id=8b696fbc&scoped=true"
import script from "./equipment4.vue?vue&type=script&lang=js"
export * from "./equipment4.vue?vue&type=script&lang=js"
import style0 from "./equipment4.vue?vue&type=style&index=0&id=8b696fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b696fbc",
  null
  
)

export default component.exports